import { useCallback, useEffect, useMemo, useState } from "react"

import { listSubject } from "../../../api/subject"
import {
  normalizeTaxonomyItems,
  taxonomyToSelectOptions,
} from "../../../utils/subjectTaxonomy"
import {
  SelectOption,
  SubjectSelectOption,
} from "../../../types/subjectSelect"

export type { SelectOption, SubjectSelectOption }

/** @deprecated Use SubjectSelectOption */
export type SubjectOption = SubjectSelectOption
export const useQuestionSubjects = () => {
  const [subjects, setSubjects] = useState<SubjectSelectOption[]>([])

  const fetchSubjects = useCallback(async () => {
    const response = await listSubject(1, "", 100000)
    const apiSubjects = response.data?.data?.subjects ?? []
    setSubjects(
      apiSubjects.map((subject: any) => ({
        value: subject.id,
        label: subject.title || "",
        topics: normalizeTaxonomyItems(subject.topics || []),
        chapters: normalizeTaxonomyItems(subject.chapters || []),
        level_labels: Array.isArray(subject.level_labels)
          ? subject.level_labels
          : undefined,
      }))
    )
  }, [])

  useEffect(() => {
    fetchSubjects().catch(() => setSubjects([]))
  }, [fetchSubjects])

  const subjectById = useCallback(
    (id?: string | null) => subjects.find((s) => s.value === id) ?? null,
    [subjects]
  )

  const topicOptionsForSubject = useCallback(
    (subject: SubjectSelectOption | null) =>
      taxonomyToSelectOptions(subject?.topics ?? []),
    []
  )

  const chapterOptionsForSubject = useCallback(
    (subject: SubjectSelectOption | null) =>
      taxonomyToSelectOptions(subject?.chapters ?? []),
    []
  )

  return useMemo(
    () => ({
      subjects,
      subjectById,
      topicOptionsForSubject,
      chapterOptionsForSubject,
    }),
    [
      subjects,
      subjectById,
      topicOptionsForSubject,
      chapterOptionsForSubject,
    ]
  )
}
